import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupSubstract2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupSubstract2"><Path d="M8.5 8.5H2.5V21.5H15.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 8.75V10V13V15.5H11H14H15.25M8.5 5V2.5H11M19 2.5H21.5V5M14 2.5H16M21.5 8V10M21.5 13V15.5H19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupSubstract2;
